import React, {useCallback, useEffect, useState} from 'react';
import {LmErrorPage, LmLoader} from "@mes-ui/lemma";
import style from './config.module.scss';
import cn from 'classnames';
import pkg from "../../package.json";

const statusValue = {
  loading: 'LOADING',
  load: 'LOAD',
  error: 'ERROR',
}

export const ConfigGuard = ({ children }) => {

  const [configStatus, setConfigStatus] = useState(null);

  const handleGetConfig = useCallback( () => {
      setConfigStatus(statusValue.loading);

      fetch(`/config.json?v=${pkg.version}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
      })
          .then(async (response) => {
              const data = await response.json();

              localStorage.setItem("aupd_config", JSON.stringify(data));

              setConfigStatus(statusValue.load);
          })
          .catch(() => {
              localStorage.setItem("aupd_config", '');
              setConfigStatus(statusValue.error);
          })
  }, [setConfigStatus])

  useEffect(() => {
      handleGetConfig();
  }, [handleGetConfig]);

  switch (configStatus) {
    case statusValue.error:
      return (
          <div className={cn(style.Config)}>
              <LmErrorPage
                  userRole="adult"
                  errorCode={503}
                  title={'Ошибка загрузки конфигурации'}
                  hideHelpInfo
              />
          </div>
      );
    case statusValue.loading:
      return (
          <div className={cn(style.Config)}>
              <LmLoader description="Загрузка конфигурации" title="Почти готово" view="page" />
          </div>
      )
    case statusValue.load:
      return <>{children}</>;
    default:
      return null;
  }
};
